import GooglePaySuccess from 'features/moveMoney/screens/GooglePay/GooglePaySuccess';
import React from 'react';

export default function GooglePaySuccessPage() {
  return <GooglePaySuccess />;
}
